import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import ContentLibraryContent from "../../components/Pages/ContentLibrary";

const { displayName } = config;

export default function ContentLibrary() {
  useEffect(() => {
    document.title = `${displayName}: Content Library`;
  }, []);

  return (
    <Layout title="Content Library">
      <ContentLibraryContent />
    </Layout>
  );
}
